import axios from 'axios';

export default {
    downloadOrganizationReportPDF(organizationId) {
        return axios.get(`/organizations/${organizationId}/report`, { responseType: 'blob' });
    }
};
